import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import TableauDash from "../../components/commonComponents/TableauDashboard/TableauDash";
import RetailAnalyticsFilter from "./Filters/RetailAnalyticsFilter";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie, checkWorkSpaceFromCookies } from "../../api_calls/userManagement";
import { resetBrandReportView, storeListOptionsForFilter, findStoreIds, findEmbeddableId } from "../../api_calls/utils";
import { useDispatch, useSelector } from "react-redux";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import { deleteItems } from "../../Store/actions";
import { resolveEmbeddableNumberRoot } from "../../api_calls/retailerSelection";
import platformConfig from "../../platformConfig";

const Optimization = () => {
  const userStateDate = useSelector((state) => state.userSelections);
  const [userInfo, setUserInfo] = React.useState({});
  const dispatchAction = useDispatch();
  const numberRoot = resolveEmbeddableNumberRoot(userInfo.root_company_id);
  const dashboardVariables = () => {
    let optimizationVariables = {};

    if (typeof userStateDate.embedded_optimization_stores !== "undefined" && typeof userStateDate.embedded_optimization_stores.store_ids !== "undefined" && userStateDate.embedded_optimization_stores.store_ids.length !== 0) {
      optimizationVariables = {
        ...optimizationVariables,
        Stores: userStateDate.embedded_optimization_stores.store_ids,
      }

    }

    if (typeof userStateDate.embedded_optimization_date !== "undefined") {
      const endDate = new Date(userStateDate?.embedded_optimization_date.to);
      endDate.setDate(endDate.getDate() + 1); // add one day to
      optimizationVariables = {
        ...optimizationVariables,
        Date: {
          from: userStateDate?.embedded_optimization_date.from,
          to: endDate
        },
      }
    }

    return optimizationVariables;
  }

  React.useEffect(() => {
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    resetBrandReportView();
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);
  return (
    <StyledMainBox component="main">
      {/* ------------- filters -------------- */}
      <RetailAnalyticsFilter
        singleStore={false}
        reduxKeyForStore="embedded_optimization_stores"
        reduxKeyForDate="embedded_optimization_date"
        usedFor="retail-analytics-journey"
      />
      <Box height={1} />
      {/* ----------- tableau dashboard ---------- */}
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" &&
          typeof userStateDate.store_dates !== "undefined" &&
          typeof userStateDate.embedded_optimization_stores !== "undefined" && (
          <Dashboard
            key={numberRoot}
            embedDashboardId={findEmbeddableId("retail_analytics", "optimization")}
            variables={dashboardVariables()}
            filterConfig={{
              "number_root": numberRoot,
            }} />
        )}
      </Grid>
    </StyledMainBox>
  );
};
// remove array if all user types are allowed. if only some are allowed, add them like below
export default AccessControl(Optimization, ["analytics_can_view"], platformConfig.retailAnalyticsAvailableFor, ["retail_analytics_section", "optimization"]);
